import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class FamiliaProdutoValidation extends DefaultValidation {
    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (isNull(model.idfamiliaerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
        }

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
        }

        return validated;
    }
}